// src/config/api.js
// URLs de Cloud Functions. Un único lugar para cambiar si el proyecto
// cambia de región, nombre o se añaden entornos (staging/prod).

const BASE = 'https://europe-west1-cookychat-10956.cloudfunctions.net';

export const API = {
  chatProxy:            `${BASE}/chatProxy`,
  parseRecipeFromAudio: `${BASE}/parseRecipeFromAudio`,
  parseRecipeFromImage: `${BASE}/parseRecipeFromImage`,
  parseRecipeFromText:  `${BASE}/parseRecipeFromText`,
};
